import { ListViewDir, ListView } from "../../../../../framework/tools/scrollview/listview";

const {ccclass, property} = cc._decorator;

@ccclass
export class EightDayListView extends cc.Component {

    @property(cc.ScrollView)
    scrollView:cc.ScrollView = null;

    @property(cc.Node)
    viewNode:cc.Node = null;

    @property(cc.Node)
    content:cc.Node = null;

    @property(cc.Node)
    prefab:cc.Node = null;

    @property(cc.Integer)
    column:number = 0
    @property(cc.Integer)
    row: number = 0
    @property(cc.Integer)
    gap_x:number = 0
    @property(cc.Integer)
    gap_y:number = 0
    @property({ type: cc.Enum(ListViewDir) })
    direction: ListViewDir = ListViewDir.Horizontal

    private mList:ListView = null;

    initListView(func:Function,target:any){
        let list: ListView = new ListView({
            scrollview: this.scrollView,
            view: this.viewNode,
            content: this.content,
            item_prefab: this.prefab,
            cb_host: target,
            item_update_func: func.bind(target),
            column: this.column,
            row: this.row,
            gap_x:this.gap_x,
            gap_y:this.gap_y,
            direction: this.direction,
        });
        this.mList = list;
    }

    setData(data:any[]){
        this.mList.set_data(data);
    }


 
}
